import React from 'react'
import { AiOutlineSearch } from 'react-icons/ai'

import { COLORS } from '../Constants'
import { useStateValue } from './StateProvider'

const SearchBar = () => {
    const [{ darkmode, outerWidth }, dispatch] = useStateValue()

    const updateSearchText = text => {
        dispatch({
            type: 'UPDATE_SEARCHTEXT',
            item: text,
        })
    }

    return (
        <div className='searchbar'>
            <div className='searchbar__canvas' style={{
                backgroundColor: darkmode ? COLORS.main_searchbar_color_dark : COLORS.main_searchbar_color_light
            }}>
                <div className='searchbar__icon'>
                    <AiOutlineSearch />
                </div>
                <input className='searchbar__input' onChange={(event) => updateSearchText(event.target.value)} placeholder='Start typing to filter ...' style={{
                    color: darkmode ? COLORS.main_font_color_dark : COLORS.main_font_color_dark
                }} type='text'></input>
            </div>
            <div className='searchbar__results'>
                
            </div>
        </div>
    )
}

export default SearchBar